import { Button } from '@ui/components';
import { t } from 'i18next';
import { FC } from 'react';

interface DashboardWalletFooterProps {
  onCtaClick: () => void;
}

export const DashboardWalletFooter: FC<DashboardWalletFooterProps> = ({ onCtaClick }) => {
  return (
    <div className="flex flex-1 items-end w-full mt-6">
      <Button onClick={onCtaClick} size="large" wide>
        {t('DASHBOARD.WALLET.TOP_UP')}
      </Button>
    </div>
  );
};
